import React, { useEffect, useState } from "react";

import Drawer from "../../components/ui/Drawer";
import "./file-upload.scss";
import { useSelector } from "react-redux";

import Table, { Row, Data } from "../../components/ui/table/table";
import Section from "../../layouts/Section";
import { fetchTransferHistory } from "../../api/card-service";

import { formatAmount, getAmountWithCurrency } from "../../utils/utils";
import { format } from "date-fns";
import { useQuery } from "@tanstack/react-query";
import { useLocale } from "../../hooks/useLocale";

const ViewTransferHistoryDrawer = ({ id, title, onClose, cardItem }) => {
  const currentUser = useSelector((s) => s.auth.currentUser);
  const { localize } = useLocale(["cards"]);

  const query = useQuery(["cards/transfer-history"], () =>
    fetchTransferHistory({
      userHashId: currentUser.userHashId,
      customerHashId: cardItem.customerHashId,
    })
  );

  return (
    <>
      <Drawer title={title} id={id} onClose={onClose} width={800}>
        <>
          <Section>
            <div className="row gy-4">
              <div className="col-sm-12 col-md-6 col-lg-4">
                <h6 className="text-uppercase">{localize("transferHistory.moxeyId")}</h6>
                <span className="text-uppercase">{cardItem.moxeyId}</span>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4">
                <h6 className="text-uppercase">{localize("transferHistory.driverName")}</h6>
                <span className="text-uppercase">
                  {cardItem.firstName} {cardItem.lastName}
                </span>
              </div>
            </div>
          </Section>

          {/* Table Data */}
          <Table
            loading={query.isFetching}
            dataSize={query.data?.content.length}
            cols={localize("transferHistory.table.cols", { returnObjects: true })}
          >
            <>
              {query.data?.content.map((item) => {
                return (
                  <>
                    <Row>
                      <Data>{item.status}</Data>
                      <Data>{item.referenceNo}</Data>
                      <Data>{item.orderId}</Data>
                      <Data>{item.paymentId}</Data>
                      <Data>{format(item.createdAt, "Pp")}</Data>
                      <Data>
                        {getAmountWithCurrency(
                          formatAmount(item.amount),
                          "AED"
                        )}
                      </Data>
                    </Row>
                  </>
                );
              })}
            </>
          </Table>
        </>
      </Drawer>
    </>
  );
};

export default ViewTransferHistoryDrawer;
